<template>
  <div>
    <label :class="['item', { 'item--disabled': !time.enabled, 'item--rental': time.rental, 'item--checked': time.checked }]" @click="changeValue">
      <div
        class="item__name text-center mx-1 my-1 mx-lg-3 my-lg-2"
        :style="time.checked && 'background-color:' + this.user.config.parameters.parameters.colorprimary"
      >
        {{ time.text }}
      </div>
    </label>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  //TODO: Consider moving all functionality of PickerTime into TimePicker since there is no functionality except visuals in here,
  // and this component is not usable without TimePicker and vice-versa. If not atleast clean up areas of resposibility, input and implement standard radiogroup functionality (Currently manually handled by TimePicker)
  name: 'PickerTime',
  props: {
    time: {
      type: Object
    },
    id: {
      type: Number
    }
  },
  methods: {
    changeValue() {
      if (this.time.enabled) {
        this.$emit('childToParent', this.time, this.id);
      }
    }
  },
  computed: mapGetters(['user'])
});
</script>

<style scoped lang="scss">
@import './src/assets/scss/_variables.scss';
.item {
  position: relative;
  cursor: pointer;

  &__name {
    font-size: 0.8125rem;
    color: $darkest;
    border: solid 2px $primaryColor;
    border-radius: 3px;
    padding: 7px 18px;
    background-color: $lightest;
  }

  &__input {
    opacity: 0;
    position: fixed;
    pointer-events: none;
  }

  &--disabled {
    .item {
      &__input {
      }
      &__name {
        color: $gray;
        border-color: $gray;
      }
    }
  }

  &--checked {
    > div {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    }
  }
}
.item.item--checked .item__name {
  color: #ffffff;
}
</style>

<i18n src="../../localization/texts.json"></i18n>
